import { useContext } from "react";
import { PlayerListContext } from "./player-list-context";

export const usePlayerListContext = () => useContext(PlayerListContext);
